module.exports = __webpack_public_path__ + "static/media/mic-connected.731cb8ea.svg";